import React from 'react';
import { useRef,useEffect,useState } from 'react';
import Page from "@/layouts/Page"
import {Link} from "react-router-dom"
import AddIcon from "@mui/icons-material/Add"
import DeleteIcon from "@mui/icons-material/Delete"
import { UserPopUpWindow } from '@/components/users/UsersPopUpWindow';
import {useAuthContext} from "@/hooks/useAuthContext"
import { useInifiniteScroll } from "@/hooks/useInifiniteScroll"
import { getAllUser } from "@/api/usuario"

enum UserRoleDisplayText
{
   admin = "Administrador",
   socio = "Socio",
   cliente = "Cliente"
}

export default function Users() {
   const {user} = useAuthContext()
   const observerRef = useRef<IntersectionObserver | null>(null);
   const loadMoreRef = useRef<HTMLDivElement>(null);
   const {data : users ,loading, error, hasMore, loadMore} = useInifiniteScroll({apiFunction:getAllUser,limit:20})
   const [popVisibility,setPopVisibility] = useState<boolean>(false)
   const [userNameDelete,setUserNameDelete] = useState<string>("")
   const [userIdDelete,setUserIdDelete] = useState<string>("")

   const handleStartDeleteUser = (name:string,id:string) => {
      setUserNameDelete(name)
      setUserIdDelete(id)
      setPopVisibility(true)
   }

   useEffect(()=>{

      if (observerRef.current) {
         observerRef.current.disconnect();
      }

      observerRef.current = new IntersectionObserver(
         (entries) => {
         if (entries[0].isIntersecting && hasMore && !loading) {
            loadMore();
         }
         },
         {
         threshold: 0.1, 
         rootMargin: '100px', 
         }
      );

      const currentRef = loadMoreRef.current;
      if (currentRef) {
         observerRef.current.observe(currentRef);
      }

      return () => {
         if (observerRef.current) {
         observerRef.current.disconnect();
         }
      };

   },[hasMore, loading, loadMore])

   return (
      <Page className="flex flex-col items-center py-12 gap-8">
         <h1 className="text-blue text-3xl font-bold text-center">Usuarios Activos en Casas Diamante</h1>
         {user.admin && (
            <Link
               to="/usuarios/agregar"
               className="py-2 px-6 rounded-full bg-blue text-white flex items-center gap-2"
            >
               <AddIcon />
               Agregar Usuario
            </Link>
         )}
   
         {error && (
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
               {error}
            </div>
         )}

         <section id = "users-info" className="grid grid-cols-1 md:grid-cols-3 xl:grid-cols-4 items-center justify-center gap-6">
            {users.map((user) => (
               <div
                  id = "single-user-cointainer"
                  key={user.id}
                  className="p-8 bg-[#F0F0F0] border border-gray-300 rounded-lg shadow-xl relative w-[300px] h-[230px]"
               >
                  <button
                        className="absolute top-2 right-2"
                        onClick={() => handleStartDeleteUser(user.nombre,user.id)}
                     >
                        <DeleteIcon/>
                  </button>
                  <h3 className="font-bold text-lg">{user.nombre}</h3>
                  <hr className="mt-2 mb-4 h-1 bg-gray-500 border"/>
                  <p className="font-bold text-green text-lg truncate">Rol: {UserRoleDisplayText[user.userRole as keyof typeof UserRoleDisplayText]}</p>
                  <p className="truncate">Email: {user.id}</p>
                  <p className="truncate">Tel: {user.telefono}</p>
               </div>
            ))}
         </section>

         <div ref={loadMoreRef} className="py-8 text-center">
            {loading && (
               <div className="flex justify-center items-center">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
                  <span className="ml-2">Cargando usuarios...</span>
               </div>
            )}
            
            {!hasMore && users.length > 0 && (
               <p className="text-gray-500">No hay más usuarios para mostrar</p>
            )}
         </div>

         
         {popVisibility && (
            <UserPopUpWindow setVisibility={setPopVisibility} name={userNameDelete} id={userIdDelete}/>
         )}

      </Page>
   )
}
